<template>
  <div class="404 text-center">
    <h1>404</h1>
    <p>Not Found</p>
    <p>You can return to the
      <n-link color="primary" @click="$router.push('/')">Home Page</n-link>.
    </p>
  </div>
</template>